<h1 class="page-header"><i class="fa fa-heartbeat" aria-hidden="true"></i> HEALTH MONITOR</h1>
<div>
  <!-- Tab Navigation Control -->
  <ul class="nav nav-tabs">
    <li class="active"><a data-toggle="tab" href="#website-tab" aria-expanded="true"><i class="fa fa-star-o"></i> WEBSITE</a></li>
    <li class=""><a data-toggle="tab" href="#server-tab" aria-expanded="false"><i class="fa fa-star-o"></i> SERVER</a></li>
    <li class=""><a data-toggle="tab" href="#database-tab" aria-expanded="false"><i class="fa fa-star-o"></i> DATABASE</a></li>
  </ul>


</div>
<!-- Tab Content -->
<div class="tab-content">
  <!-- Client Tab -->
  <div id="website-tab" class="tab-pane fade active in">

    <div class="container-fluid">
      <div id="sample">
        <div id="websiteDiagramDiv" style="border: solid 1px black; width: 100%; height: 500px;"></div>
      </div>
    </div>
  </div>


  <!-- Server Tab -->
  <div id="server-tab" class="tab-pane fade">

    <div class="container-fluid">
      <div id="sample2">
        <div id="serverDiagramDiv" style="border: solid 1px black; width: 100%; height: 500px;"></div>
      </div>
    </div>
  </div>

  <!-- Client Tab -->
  <div id="database-tab" class="tab-pane fade">

    <div class="container-fluid">
      <div id="sample3">
        <div id="databaseDiagramDiv" style="border: solid 1px black; width: 100%; height: 500px;"></div>
      </div>
    </div>
  </div>

</div>
